// extracted by css-extract-rspack-plugin
var _1 = "swLOYCr30YIdexDh";
var _2 = "swLOYCr30YIdexDh";
var _3 = "hmKp_gc0jgUk6981";
var _4 = "hmKp_gc0jgUk6981";
export { _1 as "drawvideo-other-source", _2 as "drawvideoOtherSource", _3 as "video-label", _4 as "videoLabel" }
